import { useEffect } from 'react';
import {
  DEFAULT_META,
  LOCALE,
  OG_IMAGE_HEIGHT,
  OG_IMAGE_URL,
  OG_IMAGE_WIDTH,
  SITE_NAME,
  SITE_URL,
} from '../../constants';

function setMetaTag(attr, key, content) {
  if (content === undefined || content === null || content === '') return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLinkTag(rel, href, extra = {}) {
  if (!href) return;
  const selector = extra.hreflang
    ? `link[rel="${rel}"][hreflang="${extra.hreflang}"]`
    : `link[rel="${rel}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    if (extra.hreflang) el.setAttribute('hreflang', extra.hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function PageMeta({
  title,
  description = DEFAULT_META.description,
  keywords = DEFAULT_META.keywords,
  path = '',
  noindex = false,
  image = OG_IMAGE_URL,
}) {
  const canonical = `${SITE_URL}${path}`;
  const robots = noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large';

  useEffect(() => {
    document.documentElement.lang = 'en';
    document.title = title;

    setMetaTag('name', 'description', description);
    setMetaTag('name', 'keywords', keywords);
    setMetaTag('name', 'robots', robots);
    setMetaTag('name', 'googlebot', robots);
    setMetaTag('name', 'author', 'PixelUtility');
    setMetaTag('name', 'application-name', SITE_NAME);

    setLinkTag('canonical', canonical);

    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:url', canonical);
    setMetaTag('property', 'og:type', 'website');
    setMetaTag('property', 'og:site_name', SITE_NAME);
    setMetaTag('property', 'og:locale', LOCALE);
    setMetaTag('property', 'og:image', image);
    setMetaTag('property', 'og:image:width', String(OG_IMAGE_WIDTH));
    setMetaTag('property', 'og:image:height', String(OG_IMAGE_HEIGHT));
    setMetaTag('property', 'og:image:alt', title);

    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', description);
    setMetaTag('name', 'twitter:image', image);
    setMetaTag('name', 'twitter:image:alt', title);
  }, [title, description, keywords, canonical, robots, image]);

  return null;
}
